var render, staticRenderFns
import script from "./GuideButtonRouterView.vue?vue&type=script&lang=js&"
export * from "./GuideButtonRouterView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/workspace/ecommerce_h5_dev_front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('8c8c7114', component.options)
    } else {
      api.reload('8c8c7114', component.options)
    }
    
  }
}
component.options.__file = "src/components/layouts/GuideButtonRouterView.vue"
export default component.exports